import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps } from 'react-router';

import { FormPage } from '@checkit/react-components';
import { EditIcon } from '@checkit/react-components/build/components/Icons';

import { useAxiosDispatch } from '../../middleware/axios';
import { createSnackbar } from '../../notifications/actions';
import {
  isUpdateLibrarySuccess,
  updateLibrary
} from '../actions';
import { LibraryForm } from '../form/LibraryForm';
import { LibraryDto } from '../state';

import { messages } from './UpdateLibrary.translations';

export const UpdateLibrary: React.FC<RouteComponentProps<{ libraryCode: string }>> = ({
  history,
  match
}) => {
  const { libraryCode } = match.params;

  const { formatMessage } = useIntl();
  const dispatch = useAxiosDispatch( );

  async function handleSubmit(data: LibraryDto): Promise<void> {
    const action = updateLibrary(libraryCode, data);
    await dispatch(action).then(function onSuccess(resultingAction) {
      if (!isUpdateLibrarySuccess(resultingAction)) {
        throw new Error('Resulting action of library creation is invalid');
      }
      dispatch(createSnackbar({
        message: formatMessage(messages['library.update.success']),
        options: { variant: 'success' }
      }));
    }).catch(function handleError(err) {
      dispatch(createSnackbar({
        message: formatMessage(messages['library.update.error']),
        options: { variant: 'error' }
      }));
      // re-throw the error so that the library form knows the creation failed
      throw err;
    });
  }

  return (
    <FormPage pageTitle={formatMessage(messages['library.update.pageTitle'])} pageIcon={<EditIcon />} >
      <LibraryForm code={libraryCode} history={history} handleSubmit={handleSubmit} />
    </FormPage>
  );
};
